import React, { Fragment } from 'react'
import { GallerySectionProps } from './GallerySection.types'
import styles from './GallerySection.module.scss'
// import cl from 'classnames'
import { Button, GallerySlider, Text1, Text2 } from 'components/shared'
import { IconExpand } from 'assets'

const GallerySectionComponent = (props: GallerySectionProps) => {
  const {
    children,
    title,
    count,
    addButtonProps: {
      width,
      label = 'Add',
      ...rest
    } = {}
  } = props

  return (
    <Fragment>
      {title && (
        <Text1
          bold
          className={styles.innerSectionTitle}
        >
          {title} {count !== undefined
            ? `(${count})`
            : ''}
        </Text1>
      )}

      <div className={styles.lineContainer}>

        <GallerySlider
          style={{ marginRight: 12 }}
          maxWidthCorrection={-width - 12}
        >
          {children}
        </GallerySlider>

        {width && (
          <Button
            className={styles.addEntityButton}
            style={{ height: width / 0.7, width }}
            {...rest}
          >
            <IconExpand />
            <Text2>{label}</Text2>
          </Button>
        )}

      </div>
    </Fragment>
  )
}

const GallerySection = GallerySectionComponent
export { GallerySection }
